function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.90025 11.4613C7.70537 11.6568 7.45975 11.7543 7.16508 11.7543C6.861 11.7543 6.60933 11.6568 6.40941 11.4613C6.21017 11.2661 6.11004 11.0252 6.11004 10.7389C6.11004 10.4523 6.21017 10.2134 6.40941 10.0225C6.60933 9.8317 6.861 9.73594 7.16508 9.73594C7.45975 9.73594 7.70537 9.8317 7.90025 10.0225C8.0958 10.2134 8.19357 10.4523 8.19357 10.7389C8.19357 11.0252 8.0958 11.2661 7.90025 11.4613ZM8.12839 2.54923L7.80281 8.64226H6.51391L6.20143 2.54923H8.12839ZM7.15164 0C3.20229 0 -0.00012207 3.20208 -0.00012207 7.15176C-0.00012207 11.1014 3.20229 14.3035 7.15164 14.3035C11.1013 14.3035 14.3037 11.1014 14.3037 7.15176C14.3037 3.20208 11.1013 0 7.15164 0Z",
  fill: "#F71D1D"
});

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.ab1d9700.svg";
export { ForwardRef as ReactComponent };